import { Col, Flex, Row } from '@wyz/ui';
import * as React from 'react';
import { Skeleton } from '~/common/components';

const Loader: React.FC = () => {
  return (
    <>
      <Row className='mb-3'>
        <Flex justifyContent='start'>
          <Skeleton width={250} height={20} />
        </Flex>
      </Row>

      <Row className='mb-section'>
        <Col xs={12}>
          <Skeleton width={180} height={32} />
        </Col>
      </Row>

      <Row className='mb-section'>
        <Col xs={12}>
          <Row className='gy-3 gx-4'>
            <Col xs={12} lg={4}>
              <div className='card'>
                <div className='card-body'>
                  <Skeleton width={180} height={24} className='mb-3' />
                  <Skeleton width={80} height={20} className='mb-2' />
                  <div className='mb-3'>
                    <Skeleton width={70} height={14} className='mb-2' />
                    <Skeleton width={50} height={14} className='mb-2' />
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} lg={4}>
              <div className='card'>
                <div className='card-body'>
                  <Skeleton width={120} height={14} className='mb-2' />
                  <div className='mb-2'>
                    <Skeleton width='100%' height={14} className='mb-2' />
                    <Skeleton width='100%' height={14} className='mb-2' />
                    <Skeleton width='100%' height={14} />
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} lg={4}>
              <div className='card'>
                <div className='card-body'>
                  <div className='mb-2'>
                    <Skeleton width='100%' height={14} className='mb-2' />
                    <Skeleton width='100%' height={14} className='mb-2' />
                    <Skeleton width='100%' height={14} />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={12} lg={9}>
          <div className='mb-3 d-flex justify-content-end'>
            <Skeleton width={120} height={32} />
          </div>

          <div className='card mb-3'>
            <div className='card-body'>
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div className='d-flex align-items-center gap-2'>
                  <Skeleton width={120} height={24} />
                  <Skeleton width={60} height={28} />
                </div>
                <Skeleton width={150} height={32} />
                <div className='d-flex gap-3'>
                  <Skeleton width={100} height={16} />
                  <Skeleton width={100} height={16} />
                  <Skeleton width={100} height={16} />
                </div>
              </div>
              <Skeleton width={150} height={16} className='mb-3' />
              <div className='border-top pt-3'>
                <div className='d-flex gap-2 justify-content-end'>
                  <Skeleton width={100} height={36} />
                  <Skeleton width={100} height={36} />
                </div>
              </div>
            </div>
          </div>

          <div className='card mb-3'>
            <div className='card-body'>
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div className='d-flex align-items-center gap-2'>
                  <Skeleton width={120} height={24} />
                  <Skeleton width={60} height={28} />
                </div>
                <Skeleton width={100} height={28} />
                <div className='d-flex gap-3'>
                  <Skeleton width={100} height={16} />
                  <Skeleton width={100} height={16} />
                  <Skeleton width={100} height={16} />
                </div>
              </div>
              <Skeleton width={150} height={16} className='mb-3' />
              <div className='border-top pt-3'>
                <div className='d-flex gap-2 justify-content-end'>
                  <Skeleton width={100} height={36} />
                  <Skeleton width={100} height={36} />
                </div>
              </div>
            </div>
          </div>

          <div className='card mb-3'>
            <div className='card-body'>
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div className='d-flex align-items-center gap-2'>
                  <Skeleton width={120} height={24} />
                  <Skeleton width={60} height={28} />
                </div>
                <Skeleton width={100} height={28} />
                <div className='d-flex gap-3'>
                  <Skeleton width={100} height={16} />
                  <Skeleton width={100} height={16} />
                  <Skeleton width={100} height={16} />
                </div>
              </div>
              <Skeleton width={150} height={16} className='mb-3' />
              <div className='border-top pt-3'>
                <div className='d-flex gap-2 justify-content-end'>
                  <Skeleton width={100} height={36} />
                  <Skeleton width={100} height={36} />
                </div>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={12} lg={3}>
          <div className='card mb-3'>
            <div className='card-body'>
              <Skeleton width={140} height={18} className='mb-3' />
              <div className='border-bottom pb-3 mb-3'>
                <div className='d-flex justify-content-end gap-3 mb-2'>
                  <Skeleton width={90} height={14} />
                  <Skeleton width={80} height={14} />
                </div>
              </div>
              <div className='mb-2'>
                <div className='d-flex justify-content-between align-items-center'>
                  <Skeleton width={80} height={14} />
                  <div className='d-flex gap-3'>
                    <Skeleton width={60} height={14} />
                    <Skeleton width={60} height={14} />
                  </div>
                </div>
              </div>
              <div className='mb-2'>
                <div className='d-flex justify-content-between align-items-center'>
                  <Skeleton width={90} height={14} />
                  <div className='d-flex gap-3'>
                    <Skeleton width={60} height={14} />
                    <Skeleton width={60} height={14} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='card mb-3'>
            <div className='card-body'>
              <Skeleton width={150} height={18} className='mb-3' />
              <Skeleton width='100%' height={120} />
            </div>
          </div>

          <div className='card mb-3'>
            <div className='card-body'>
              <Skeleton width={150} height={18} className='mb-3' />
              <Skeleton width='100%' height={120} className='mb-3' />
              <Skeleton width='100%' height={36} />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Loader;
